import { render, staticRenderFns } from "./GoodsPromote.vue?vue&type=template&id=c4161700&scoped=true"
import script from "./GoodsPromote.vue?vue&type=script&lang=js"
export * from "./GoodsPromote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4161700",
  null
  
)

export default component.exports